import React from 'react'

const InputLabel = ({label,width="50%"}) => {
  return (
    <div style={{width:width,alignContent:'center',whiteSpace:'nowrap'}} className='text-white flex align-center flex-wrap'>{label}<span>{" "} :{" "}</span></div>
  )
}

export default InputLabel